import React from 'react';
import styled from 'astroturf/react';

import { Body as BodyBase } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { User } from 'js/social/UserCard';
import _Container from "Header-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Header.tsx?styleId=Container";
import _NameContainer from "Header-NameContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Header.tsx?styleId=NameContainer";
import _CommenterName from "Header-CommenterName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Header.tsx?styleId=CommenterName";
import _CommenterAffiliation from "Header-CommenterAffiliation.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Header.tsx?styleId=CommenterAffiliation";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const NameContainer = /*#__PURE__*/styled("div", null, {
  displayName: "NameContainer",
  styles: _NameContainer
});

const CommenterName = /*#__PURE__*/styled(BodyLink, null, {
  displayName: "CommenterName",
  styles: _CommenterName
});

const CommenterAffiliation = /*#__PURE__*/styled(BodyBase, null, {
  displayName: "CommenterAffiliation",
  styles: _CommenterAffiliation
});

interface Props {
  commenter: User;
  commenterUrl?: string;
  headerMenu?: React.ReactNode;
}

const Header: React.FunctionComponent<Props> = ({
  commenter,
  commenterUrl,
  headerMenu,
}) => (
  <Container>
    <NameContainer>
      <CommenterName size="sm" bold href={commenterUrl}>
        {commenter.displayName}
      </CommenterName>

      {headerMenu}
    </NameContainer>

    {commenter.affiliation && (
      <CommenterAffiliation size="xs">
        {commenter.affiliation}
      </CommenterAffiliation>
    )}
  </Container>
);

export default Header;
